import { toast } from 'react-hot-toast'

export const infoToast = (msg: string) => toast.success(msg.toString())
export const errorToast = (msg: string) => toast.error(msg.toString())
